import { createSelector } from 'reselect';
const ALL_LOADING_EXCHANGE_TYPES = [
    'all',
    'exchange-variants',
    'exchange-price',
    'auto-create-exchange'
];
export const getIsLoadingState = (state) => state.exchange.isLoading;
export const getIsLoadingExchange = createSelector(getIsLoadingState, loadingState => ALL_LOADING_EXCHANGE_TYPES.includes(loadingState));
export const getIsLoadingByType = (loadingType) => createSelector(getIsLoadingState, loadingState => loadingState === loadingType);
